import useFetch from '@hooks/useFetch';

export const getKey = (goalUID) =>
  `v1/uplus/feedbacks/?limit=4&offset=0&goal_uid=${goalUID}`;

const useBatchFeedback = (goalUID) => {
  const key = getKey(goalUID);

  const { data: batchFeedback, ...rest } = useFetch(goalUID ? key : null);

  return {
    key,
    batchFeedback,
    ...rest
  };
};

export default useBatchFeedback;
